import { faStore } from '@fortawesome/free-solid-svg-icons';
import React, { useContext, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import { Role } from '../utils/Enums/Roles';
import { getInvoiceBranchId } from '../utils/clients-hooks';
import { useTranslation } from 'react-i18next';
import { useOpenBranchCard } from '../utils/useOpenBranchCard';
import { CustomButton } from './CustomButton';

/**
 * Отваря картона на обекта направо от реда на фактурата.
 *
 * Съществува заради имейлите: фактура не тръгва, когато няма адрес, а адресът се пише в картона. Без този
 * бутон операторът трябва да излезе от фактурите, да намери обекта и да се върне.
 *
 * Id-то на обекта се пита при натискане. Първо се четеше от document.branchId, което идва наготово в реда,
 * но една на всеки десет фактури сочи документ без него и бутонът излизаше сив без причина - самата
 * фактура винаги знае обекта си.
 *
 * Самото отваряне е в {@link useOpenBranchCard}, общо с останалите екрани, откъдето се стига до картона.
 */
export const BranchActionComponent = ({
                                          invoiceId,
                                          openingBalanceId,
                                          companyName,
                                          accessEditRoles,
                                      }: {
    invoiceId?: number;
    openingBalanceId?: number;
    companyName?: string;
    accessEditRoles?: Role[];
}) => {
    const { hasPermission } = useContext(AuthContext);
    const { t } = useTranslation('translation', { keyPrefix: 'openingBalances' });
    const { open, loading: openingCard, branchCard } = useOpenBranchCard();
    const [resolvingBranch, setResolvingBranch] = useState(false);

    const openBranch = async () => {
        if (openingBalanceId || !invoiceId || !companyName) return;

        setResolvingBranch(true);
        try {
            // Грешките минават през глобалния интерцептор, който сам показва съобщение.
            const { branchId } = await getInvoiceBranchId(invoiceId);
            await open(branchId, companyName);
        } finally {
            setResolvingBranch(false);
        }

    };

    if (resolvingBranch || openingCard) {
        return <Spinner animation='border' size='sm' className='me-1' />;
    }

    return (
        <>
            <span title={openingBalanceId ? t('branchNavigationDisabled') : undefined}>
            <CustomButton
                icon={faStore}
                iconClass='fa-fw'
                onClick={openBranch}
                className='me-1 color-main'
                disabled={
                    !!openingBalanceId || !invoiceId ||
                    !companyName ||
                    (accessEditRoles && !hasPermission([...accessEditRoles, Role.ADMIN]))
                }
            />
            </span>
            {branchCard}
        </>
    );
};
